import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import _ from "i18n";
import { setSubMenuDirection, setSwitchSpace } from "Actions";
import { VERTICAL, HORIZONTAL } from "Config";
import { ICONS, SvgIcon, StatisticsIcon } from "../Common/Icons";
import { Avatar, Badge } from "antd";
import {
  isAdminAccess,
  isSuperAdminAccess,
  isManagerAccess,
  isCollaboratorAccess,
  isSupervisorAccess,
  getCookie,
  setCookie
} from "Utils";
import SettingsLink from "./SettingsLink";
import classnames from "classnames";
import { Select } from "antd";
import { push } from "react-router-redux";

class SubMenu extends Component {
  constructor(props) {
    super(props);
    const cookie = getCookie("SWITCH_USER_TEAM");
    if (this.props.loggedAs === "MANAGER" && cookie) {
      this.props.switchSpace(cookie);
    }
    this.state = {
      switchUser: cookie ? cookie : "MANAGER"
    };
  }

  handleClick = () =>
    this.props.setSubMenuDirection(
      this.props.subMenuDirection === VERTICAL ? HORIZONTAL : VERTICAL
    );

  handleClickSwitchUser = () => {
    const { switchUser } = this.state;
    const { pushUrl } = this.props;
    if (switchUser === "COLLABORATOR") {
      pushUrl("/");
    } else {
      pushUrl("/collaborator-space");
    }

    let switchSpace =
      switchUser === "COLLABORATOR" ? "MANAGER" : "COLLABORATOR";
    this.setState({
      switchUser: switchSpace
    });
    this.setCookieSwitchUser(switchSpace);
    this.props.switchSpace(switchSpace);
  };

  setCookieSwitchUser = user => {
    const dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
    setCookie(`SWITCH_USER_TEAM`, user, dtExpire, "/", "tamtam.pro");
  };

  render() {
    const {
      subMenuDirection,
      subMenuDirectionToggle,
      auth,
      gdNotifications
    } = this.props;

    let hideMenu = false;

    const { loggedAs, spaceAs, withoutHeader } = auth;

    // if (loggedAs === "GUEST") return null;

    if (hideMenu) return null;

    const { Option } = Select;

    return (
      <nav
        id="subMenu"
        className={`sub-menu ${
          subMenuDirection === VERTICAL ? "vertical" : ""
        }`}
      >
        {subMenuDirectionToggle ? (
          <span
            className="flip-menu flex-column-center"
            onClick={this.handleClick}
          >
            <img
              className="icomoon"
              src="/img/icons/menu_direction.svg"
              alt={""}
            />
          </span>
        ) : null}
        {isManagerAccess(loggedAs, spaceAs) ||
        isSupervisorAccess(loggedAs) ||
        isAdminAccess(loggedAs, spaceAs) ||
        isSuperAdminAccess(loggedAs, spaceAs) ? (
          <ul className="menu">
            <li>
              <NavLink
                to={"/clients"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.CLIENT_LIST_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("clientList")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/capacity-planing/production"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.COLLABORATOR_LIST_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                {/*<span className="title">{_("collaboratorList")}</span>*/}
                <span className="title">{_("Collaborateurs")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/time-sheet"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.TIME_SHEET_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("MyTimeSheet")}</span>
              </NavLink>
            </li>

            {/*     <li>
              <NavLink
                to={"/category-statistics"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.CATEGORY_STATISTICS_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("categories")}</span>
              </NavLink>
            </li>*/}

            <div className={"settings-menu"} style={{ width: "150px" }}>
              <div className={"settings-menu-drop-down"}>
                <li>
                  <SvgIcon
                    icon={ICONS.BUDGET_PAGE_ICON}
                    className={"light-sub-menu-icon"}
                  />
                  <span>{_("budget")}</span>
                </li>
                <i className={classnames("icon icon-arrow-down")} />
              </div>

              <div className={"settings-list"}>
                <NavLink to={"/budget"}>{_("budget")}</NavLink>

                <NavLink to={"/dynamic-table"}>{_("dynamicTable")}</NavLink>

                <NavLink to={"/financial"}>{_("FinancialStatement")}</NavLink>
              </div>
            </div>

            <li>
              <NavLink
                to={"/calendar"}
                activeClassName="active"
                className="menu__link"
              >
                <StatisticsIcon className={"light-sub-menu-icon"} />
                <span className="title">{_("capacityPlaning")}</span>
              </NavLink>
            </li>

            {/*            <li>
              <NavLink
                to={"/budget"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.BUDGET_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("budget")}</span>
              </NavLink>
            </li>*/}

            {/* <li>
              <NavLink
                to={"/financial"}
                activeClassName="active"
                className="menu__link"
              >
                <FinancialIcon className={"light-sub-menu-icon"} />
                <span className="title">{_("FinancialStatement")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/dynamic-table"}
                activeClassName="active"
                className="menu__link"
              >
                <FinancialIcon className={"light-sub-menu-icon"} />
                <span className="title">{_("dynamicTable")}</span>
              </NavLink>
            </li>*/}
            {withoutHeader ? (
              <li>
                <SettingsLink />
              </li>
            ) : (
              ""
            )}
          </ul>
        ) : isCollaboratorAccess(loggedAs, spaceAs) ? (
          <ul className="menu">
            <li>
              <NavLink
                to={"/collaborator-space"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.COLLABORATOR_SPACE_PAGE_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("collaboratorSpace")}</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to={`/collaborator-calendar`}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.CALENDAR}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("myCalendar")}</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to={"/collaborator-folders"}
                activeClassName="active"
                className="menu__link"
              >
                <SvgIcon
                  icon={ICONS.FOLDERS_ICON}
                  className={"light-sub-menu-icon"}
                />
                <span className="title">{_("Mes Dossiers")}</span>
              </NavLink>
            </li>
          </ul>
        ) : (
          <ul className="menu" />
        )}

        <div className={"notifications"}>
          {/*if collabs exists we show the number*/}
          <Badge
            count={
              gdNotifications && gdNotifications.length > 0
                ? gdNotifications.length
                : 0
            }
            className={classnames(
              "notification_badge",
              withoutHeader && gdNotifications && gdNotifications.length > 0
                ? "notifications_without_header"
                : ""
            )}
          >
            <Avatar
              shape="circle"
              size="default"
              icon="bell" // mail or bell
              className={classnames("avatar")}
            />
          </Badge>
          {/*if collabs don't exists we don't show the number*/}
          {/*
           <Avatar
              shape="circle"
              size="default"
              icon="mail" // mail or bell
              className={classnames("avatar")}
            />
          */}
          <div
            className={"notifications_list"}
            style={{ right: !withoutHeader ? "1rem" : "" }}
          >
            <div className={"list"}>
              {gdNotifications && gdNotifications.length > 0 ? (
                gdNotifications.map(notif => <li>{notif.name}</li>)
              ) : (
                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                  {" "}
                  Aucune notification n'est disponible{" "}
                </div>
              )}
            </div>
          </div>
        </div>

        {withoutHeader ? (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex"
            }}
          >
            <Select
              defaultValue={
                this.state.switchUser === "COLLABORATOR"
                  ? _("collaboratorSpace")
                  : _("Espace Manager")
              }
              style={{ width: 175, color: "white", marginRight: "0.5rem" }}
              onChange={this.handleClickSwitchUser}
              id={"select_switch_space"}
            >
              {this.state.switchUser === "COLLABORATOR" ? (
                <Option
                  style={{
                    textAlign: "center"
                  }}
                  value={"managerSpace"}
                >
                  {_("Espace Manager")}
                </Option>
              ) : (
                <Option
                  style={{
                    textAlign: "center"
                  }}
                  value={"collaboratorSpace"}
                >
                  {_("collaboratorSpace")}
                </Option>
              )}
            </Select>
          </div>
        ) : (
          ""
        )}
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  currentOrganization: state.auth.currentOrganization,
  subMenuDirection: state.params.subMenuDirection,
  subMenuDirectionToggle: state.params.subMenuDirectionToggle,
  currentNavPage: state.params.currentNavPage,
  gdNotifications: state.collaborator.gdNotifications
});

const mapDispatchToProps = dispatch => ({
  setSubMenuDirection: direction => dispatch(setSubMenuDirection(direction)),
  pushUrl: url => dispatch(push(url)),
  switchSpace: user => dispatch(setSwitchSpace(user))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubMenu);



// WEBPACK FOOTER //
// ./src/components/SubMenu/SubMenu.js